export default {"src":"/_next/static/media/partner19.20c240ca.svg","height":84,"width":149,"blurWidth":0,"blurHeight":0};